import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface PreviewContextType {
  isPreviewMode: boolean;
  siteId?: string;
}

const PreviewContext = createContext<PreviewContextType>({
  isPreviewMode: false,
  siteId: undefined,
});

// eslint-disable-next-line react-refresh/only-export-components
export const usePreviewContext = () => {
  const context = useContext(PreviewContext);
  if (!context) {
    // Return default values if context is not available
    return {
      isPreviewMode: false,
      siteId: undefined,
    };
  }
  return context;
};

interface PreviewProviderProps {
  children: ReactNode;
  isPreviewMode: boolean;
  siteId?: string;
}

export const PreviewProvider: React.FC<PreviewProviderProps> = ({
  children,
  isPreviewMode,
  siteId,
}) => {
  return (
    <PreviewContext.Provider value={{ isPreviewMode, siteId }}>{children}</PreviewContext.Provider>
  );
};

export default PreviewContext;
